import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

/**
 * Defines the file type
 */
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
/**
 * Defines the file extension
 */
const EXCEL_EXTENSION = '.xlsx';


/**
 * Injectable
 */
@Injectable(
  { providedIn: 'root' }
)
  /**
   * Excel service
   */
export class ExcelService {
  /**
   * Excel service constructor
   */
  constructor() { }

  /**
  * Export JSON data as an Excel file.
  * @param json JSON data to export
  * @param excelFileName Name of the Excel file
  */
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  /**
   * Save the Excel file with the given buffer and file name.
   * @param buffer Excel file buffer
   * @param fileName Name of the Excel file
   */
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  /**
   * Save a blob as an Excel file with a timestamp appended to the file name.
   * @param buffer Blob data
   * @param fileName Name of the Excel file
   */
  public saveBlobAsExcelFile_WithTimeStamp(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  /**
  * Save a blob as an Excel file.
  * @param buffer Blob data
  * @param fileName Name of the Excel file
  */
  public saveBlobAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
